<template>
	<v-container>
		<WaitDialog :isActive="isWaiting" title="What are you waiting for?" />

		<v-tabs v-model="tab">
			<v-tab value="1">Colors</v-tab>
			<v-tab value="2">Buttons</v-tab>
			<v-tab value="3">Notifications</v-tab>
			<v-tab value="4">Dialogs</v-tab>
			<v-tab value="5">Data</v-tab>
		</v-tabs>
		<v-tabs-window v-model="tab">
			<v-tabs-window-item value="1">
				<v-container>
					<v-row>
						<v-col cols="3" md="3">
							<v-card title="Primary Container" class="pc text-left">
								<v-card-text>
									This is what text looks like on a primary container.
								</v-card-text>
								<v-card-actions>
									<m-btn text="Action 1" color="primary" />
									<m-btn text="Action 2" />
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col cols="3" md="3">
							<v-card title="Secondary Container"
								class="sc text-left">
								<v-card-text>
									This is what text looks like on a secondary container.
								</v-card-text>
								<v-card-actions>
									<m-btn text="Action 1" color="secondary" />
									<m-btn text="Action 2" />
								</v-card-actions>
							</v-card>
						</v-col>
						<v-col cols="3" md="3">
							<v-card title="Tertiary Container"
								class="tc text-left">
								<v-card-text>
									This is what text looks like on a tertiary container.
								</v-card-text>
								<v-card-actions>
									<m-btn text="Action 1" color="tertiary" />
									<m-btn text="Action 2" />
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="3">
							<v-card title="Success" class="bg-success text-on-success text-left">
								<v-card-text>
									This is what success looks like.
								</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="3">
							<v-card title="Information" class="bg-info text-on-info text-left">
								<v-card-text>
									This is what information looks like.
								</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="3">
							<v-card title="Warnings" class="bg-warning text-on-warning text-left">
								<v-card-text>
									This is what warnings looks like.
								</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="3">
							<v-card title="Errors" class="bg-error text-on-error text-left">
								<v-card-text>
									This is what errors looks like.
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-tabs-window-item>
			<v-tabs-window-item value="2">
				<v-container>
					<v-row>
						<v-col cols="12" md="12">
							<v-card title="Basic" class="text-left btns">
								<v-row class="pa-4">
									<v-col cols="2">
										<m-btn text="Default" />
									</v-col>
									<v-col cols="2">
										<m-btn color="primary" text="Primary" />
									</v-col>
									<v-col cols="2">
										<m-btn color="secondary" text="Secondary" />
									</v-col>
									<v-col cols="2">
										<m-btn color="tertiary" text="Tertiary" />
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-tabs-window-item>
			<v-tabs-window-item value="3">
				<v-container>
					<v-row>
						<v-col cols="12" md="12">
							<v-card title="Toasts" class="text-left btns">
								<v-row class="pa-4">
									<v-col cols="3">
										<m-btn text="Success" @click="tell.success('Whew. That worked.')" />
									</v-col>
									<v-col cols="3">
										<m-btn text="Information" @click="tell.info('Very informative stuff.')" />
									</v-col>
									<v-col cols="3">
										<m-btn text="Warning" @click="tell.warning('Something bad is about to happen.')" />
									</v-col>
									<v-col cols="3">
										<m-btn text="Error" @click="tell.error('You broke it.')" />
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-card title="App Notifications" class="text-left btns">
								<v-row class="pa-4">
									<v-col cols="3">
										<m-btn text="Basic" @click="sendAppNotification" />
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-card title="User Notifications" class="text-left btns">
								<v-row class="pa-4">
									<v-col cols="3">
										<UserNotification message="This is an error notification." type="error" />
									</v-col>
									<v-col cols="3">
										<UserNotification message="This is a warning notification." type="warning" />
									</v-col>
									<v-col cols="3">
										<UserNotification message="This is an info notification." type="info" />
									</v-col>
									<v-col cols="3">
										<UserNotification message="This is a success notification." type="success" />
									</v-col>
								</v-row>

							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-tabs-window-item>
			<v-tabs-window-item value="4">
				<v-container>
					<v-row>
						<v-col cols="12" md="12">
							<v-card title="Dialogs" class="text-left">
								<v-row class="pa-4">
									<v-col cols="3">
										<v-dialog v-model="dialog" max-width="400" persistent>
											<template v-slot:activator="{ props: activatorProps }">
												<m-btn v-bind="activatorProps" class="moe-button">
													Confirmation
												</m-btn>
											</template>

											<v-card prepend-icon="mdi-map-marker" text="Do you really want to do that?"
												title="Are you sure?">
												<template v-slot:actions>
													<v-spacer></v-spacer>

													<m-btn @click="dialog = false" text="Nevermind" color="primary" />

													<m-btn @click="confirmDialog" text="Yes!" />
												</template>
											</v-card>
										</v-dialog>
									</v-col>
									<v-col cols="3">
										<m-btn @click="startWaiting" text="Wait for it..." />
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-tabs-window-item>
			<v-tabs-window-item value="5">
				<v-container>
					<v-row>
						<v-col cols="12" md="12">
							<v-card class="text-left">
								<v-data-table :headers="headers" :items="drivers" :items-per-page="itemsPerPage" :page="page"
									class="elevation-1" show-current-page :footer-props="{
										itemsPerPageOptions: [5, 10, 20],
										showFirstLastPage: true
									}">
									<template #top>
										<v-toolbar flat>
											<v-toolbar-title>Table Title + Toolbar (if needed)</v-toolbar-title>
											<v-divider class="mx-4" inset vertical />
											<m-btn color="primary" prepend-icon="mdi-plus">Add</m-btn>
											<m-btn class="mx-2" prepend-icon="mdi-download">Export</m-btn>
											<m-btn prepend-icon="mdi-refresh">Refresh</m-btn>
										</v-toolbar>
									</template>
								</v-data-table>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-tabs-window-item>
		</v-tabs-window>

	</v-container>
</template>

<script lang="ts">
import { ref, onMounted, computed, inject } from 'vue';
import WaitDialog from '@/components/WaitDialog.vue';
import MBtn from '@/components/BaseButton.vue';
import UserNotification from '@/components/UserNotification.vue';
import { Tell } from '@/services/Tell';
import { SignalRMessageService } from '@/services/SignalRMessageService';
import { MessageService } from '@/contracts/MessageService';
import { EventBus, Events } from '@/contracts/EventBus';
import { AppNotification } from '@/models/NotificationModels';

interface Driver {
	firstName: string
	lastName: string
	licenseNumber: string
	dob: string
}

const drivers = ref<Driver[]>([
	{ firstName: 'John', lastName: 'Doe', licenseNumber: 'XYZ123', dob: '1990-01-01' },
	{ firstName: 'Jane', lastName: 'Smith', licenseNumber: 'ABC456', dob: '1985-05-15' },
	// Add more as needed
]);

const headers = ref([
	{ title: 'First Name', key: 'firstName' },
	{ title: 'Last Name', key: 'lastName' },
	{ title: 'License Number', key: 'licenseNumber' },
	{ title: 'Date of Birth', key: 'dob' },
]);

export default {
	//name doesn't match the file name, but we're doing it like this for uri simplicity on Entra config
	//and for clarity on the vue app
	name: 'StyleGuide',
	route: {
		path: '/style-guide',
		meta: {
			requiresAuth: true,
			title: 'Style Guide'
		}
	},
	components: {
		WaitDialog,
		MBtn,
		UserNotification
	},
	props: {
		//these properties are exposed to consumers of this component
	},
	setup() {
		const dialog = ref<boolean>(false);
		const isWaiting = ref<boolean>(false);

		const tell = inject('tell') as Tell;
		const eventBus = inject('eventBus') as EventBus;
		const tab = ref<string>("1");
		const page = ref<number>(1);
		const itemsPerPage = ref<number>(5);

		const confirmDialog = () => {
			dialog.value = false;
		}

		const sendAppNotification = () => {
			eventBus.emit(Events.NOTIFICATION_RECEIVED, new AppNotification({
				message: 'Something happened in the application',
				title: 'Test Notification'
			}));
		}

		const startWaiting = () => {
			isWaiting.value = true;
			setTimeout(() => {
				isWaiting.value = false;
			}, 3000);
		}

		onMounted(async () => {
			//do something when the component is mounted
			// await messageService.start('documents');

			// messageService.onMessage('generated', (message: DocsGeneratedMessage) => {
			// 	tell.success("Docs generated for policy: " + message.PolicyNumber);
			// });
		});

		const pageCount = computed(() => Math.ceil(drivers.value.length / itemsPerPage.value))
		const pageStart = computed(() => (page.value - 1) * itemsPerPage.value + 1)
		const pageEnd = computed(() => Math.min(page.value * itemsPerPage.value, drivers.value.length))

		return {
			dialog,
			isWaiting,
			tab,
			drivers,
			headers,
			page,
			itemsPerPage,
			pageCount,
			pageStart,
			pageEnd,
			confirmDialog,
			startWaiting,
			sendAppNotification,
			tell
		}
	}
}
</script>
<style scoped>
button {
	margin-right: var(--v-spacing-default);
}
</style>